import { useFonts } from "expo-font";

export default function useAppFonts() {
  const [fontIsReady] = useFonts({
    thinFA: require("../asset/fonts/IRANYekanMobile-Thin-FA.ttf"),
    lightFA: require("../asset/fonts/IRANYekanMobile-Light-FA.ttf"),
    regularFA: require("../asset/fonts/IRANYekanMobile-Regular-FA.ttf"),
    mediumFA: require("../asset/fonts/IRANYekanMobile-Medium-FA.ttf"),
    boldFA: require("../asset/fonts/IRANYekanMobile-Bold-FA.ttf"),
    extraBoldFA: require("../asset/fonts/IRANYekanMobile-ExtraBold-FA.ttf"),
    blackFA: require("../asset/fonts/IRANYekanMobile-Black-FA.ttf"),
    extraBlackFA: require("../asset/fonts/IRANYekanMobile-ExtraBlack-FA.ttf"),
    thinEN: require("../asset/fonts/IRANYekanMobile-Thin-EN.ttf"),
    lightEN: require("../asset/fonts/IRANYekanMobile-Light-EN.ttf"),
    regularEN: require("../asset/fonts/IRANYekanMobile-Regular-EN.ttf"),
    mediumEN: require("../asset/fonts/IRANYekanMobile-Medium-EN.ttf"),
    boldEN: require("../asset/fonts/IRANYekanMobile-Bold-EN.ttf"),
    extraBoldEN: require("../asset/fonts/IRANYekanMobile-ExtraBold-EN.ttf"),
    blackEN: require("../asset/fonts/IRANYekanMobile-Black-EN.ttf"),
    extraBlackEN: require("../asset/fonts/IRANYekanMobile-ExtraBlack-EN.ttf"),
  });

  return { fontIsReady };
}
